import { Component, OnInit, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { CategoryService } from '../../../../../services/category.service';
import { Validation } from '../../../error/error-messages/validator-messages';
import { Category, ICategory } from '../../../../../models/category.model';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../../services/auth.service';
import { RoleService } from '../../../../../services/role.service';
import { Router } from '@angular/router';
import { NameValidator } from '../../../validators/name.validator';
import { ProductService } from '../../../../../services/product.service';
import { IProductType, ProductType } from '../../../../../models/productType.model';
import { UploadService } from '../../../../../services/upload.service';
import { Shop } from '../../../../../models/shop.model';

@Component({
  selector: 'app-categorie-shop',
  templateUrl: './categorie-shop.component.html',
  styleUrls: ['./categorie-shop.component.scss']
})
export class CategorieShopComponent implements OnInit {

  url_photo: string;
  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton2') closebutton2;

  constructor(private fb: FormBuilder, private categorieService: CategoryService,
    private authService: AuthService, private productService: ProductService,
    private roleService: RoleService, private router: Router, private uploadService: UploadService) { }

  // @ts-ignore
  categorie: Category[] = [];

  // @ts-ignore
  productTypeCategory: ProductType[] = [];
  catagorieTmp: Category[] = [];
  shopCategory: Shop [] = []
  alreadyExist: boolean = false;

  // @ts-ignore
  currentCategorie: ICategory = [];

  // 👧🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥--------------- file input
  url: any;
  msg!: string;
  image: any;


  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems: any;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 25, 50, 100];
  search: any;

  // @ts-ignore
  user: User = [];

  dropdownSettings = {};
  dropdownSettingsCategorie = {};
  dropdownSettingShop= {};

  selectedProductTypes: any[] = [];
  selectedShops: any[] = [];
  selectedCategory: any = [];
  categories: any[] = [];
  c: any = { productTypes: [] };

  /*
  end for all page
   */
  sorted = false;
  sorted1 = false;

  ngOnInit(): void {
    this.loadCategorie();
    this.loadCategorieAll();
    this.url_photo = environment.url_photo;
    this.loadPersonalInformation();
    this.dropdownSettings = {
      singleSelection: false,
      text: "Sélectionnez une sous-catégorie",
      searchPlaceholderText: "Recherchez...",
      selectAllText: 'Tout sélectionner',
      unSelectAllText: 'Tout désélectionner',
      enableSearchFilter: true,
      classes: "myclass custom-class",
      textField: 'name',
      idField: 'id',
      labelKey: 'name',
      primaryKey: 'id',
    };

    this.dropdownSettingShop = {
      singleSelection: false,
      text: "Sélectionnez une boutique",
      searchPlaceholderText: "Recherchez...",
      selectAllText: 'Tout sélectionner',
      unSelectAllText: 'Tout désélectionner',
      enableSearchFilter: true,
      classes: "myclass custom-class",
      textField: 'name',
      idField: 'id',
      labelKey: 'name',
      primaryKey: 'id',
    };

    this.dropdownSettingsCategorie = {
      singleSelection: true,
      //limitSelection: 1,
      text: "Sélectionnez une catégorie",
      searchPlaceholderText: "Recherchez...",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      textField: 'name',
      idField: 'id',
      labelKey: 'name',
      primaryKey: 'id',
    };
  }

  // Déplacer les sous-catégories sélectionnés
  moveProductTypes() {
    if (!this.selectedProductTypes.length || !this.selectedCategory) {
      Swal.fire({
        position: 'top-end',
        icon: 'info',
        title: 'Veuillez sélectionner au moins un type de produit et une catégorie.',
        showConfirmButton: false,
        timer: 3000
      });
      return
    }

    const idCategorieA = this.selectedProductTypes[0]?.id;
    const idCategorieB = this.selectedCategory[0]?.id;

    this.categorieService.moveProductTypesList(this.selectedProductTypes, idCategorieB).subscribe({
      next: () => {
        // alert('Déplacement effectué avec succès !');
        this.selectedProductTypes = [];
        this.selectedCategory = null;

        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Sous Catégories déplacées avec succés',
          showConfirmButton: false,
          timer: 1500
        });
        this.loadCategorie();
        this.close();
      },
      error: (error) => {
        console.error('Erreur lors du déplacement :', error);
        alert('Erreur lors du déplacement. Veuillez réessayer.');
      }
    });
  }

  moveProductType(id: number) {
    this.categorieService.getproductTypeByCategory(id).subscribe((data: any) => {
      this.productTypeCategory = data;
      console.log('----->  this.productTypeCategory', this.productTypeCategory);
    }, (err) => {
      //console.log('-----> err', err);
    });

    this.categoryAngularList = this.categoryAngularList.filter(c => c.id != id)
  }

    // Déplacer les shop sélectionnés
    changeCatForShop() {
      if (!this.selectedShops.length || !this.selectedCategory) {
        Swal.fire({
          position: 'top-end',
          icon: 'info',
          title: 'Veuillez sélectionner au moins une boutique et une catégorie.',
          showConfirmButton: false,
          timer: 3000
        });
        return
      }
      

      
  
      const idCategorieA = this.selectedShops[0]?.id;
      const idCategorieB = this.selectedCategory[0]?.id;
  
      this.categorieService.changeCayegorieForShopList(this.selectedShops, idCategorieB).subscribe({
        next: () => {
          // alert('Déplacement effectué avec succès !');
          this.selectedShops = [];
          this.selectedCategory = null;
  
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Boutiques modifiées avec succés',
            showConfirmButton: false,
            timer: 1500
          });
          this.loadCategorie();
          this.close();
        },
        error: (error) => {
          console.error('Erreur lors du déplacement :', error);
          alert('Erreur lors du déplacement. Veuillez réessayer.');
        }
      });
    }

  moveCategoriForShopType(id: number) {
    this.categorieService.getShopByCategory(id).subscribe((data: any) => {
      this.shopCategory = data;
      console.log('----->  this.shopCategory', this.shopCategory);
    }, (err) => {
      //console.log('-----> err', err);
    });

    this.categoryAngularList = this.categoryAngularList.filter(c => c.id != id)
  }

  loadCategorie = () => {
    this.categorieService.getAllCategories_v3(this.pageNumber - 1, this.pageSize, this.search).subscribe((data: any) => {
      this.categorie = data.content;
      this.catagorieTmp = data.content;
      this.totalItems = data.totalElements;
      // console.log("Categorie.........")
      // console.log(data)
    }, (err) => {
      //console.log('-----> err', err);
    });
  }
  categoryAngularList: Category[] = [];
  loadCategorieAll = () => {
    this.categorieService.getAllCategories_v3(0, 1000, this.search).subscribe((data: any) => {
      this.categoryAngularList = data.content;

    }, (err) => {
      //console.log('-----> err', err);
    });
  }

  editForm = this.fb.group({
    name: new FormControl('', [Validators.required, Validators.minLength(2), Validators.pattern('^[A-Z-a-z-àéèêëûüîïôö -]+$')]),
    description: new FormControl('', [Validation.descriptionValidator("La description")]),
    image: new FormControl('', []),
    kahpooCommision: new FormControl('', [Validators.pattern('^[0-9.]+$')])
  });

  get updateName() {
    return this.editForm.get('name');
  }

  get updateKahpooCommision() {
    return this.editForm.get('kahpooCommision');
  }

  categorieForm = this.fb.group({
    name: new FormControl('', [Validators.required, NameValidator.notOnlyWhitespace, NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.pattern('^[A-Z-a-z-àéèêëûüîïôö -]+$')]),
    description: new FormControl('', [Validation.descriptionValidator("La description"),]),
    image: new FormControl(''),
    kahpooCommision: new FormControl('', [Validators.required, Validators.pattern('^[0-9.]+$')])
  });

  get name() {
    return this.categorieForm.get('name');
  }

  get catImage() {
    return this.categorieForm.get('image');
  }
  currentProductType: ICategory;

  // onDetailCategory(cat: ICategory) {
  //   this.currentProductType = cat;
  //   this.categorieService.getIdCategory(cat.id).subscribe(data => {
  //     console.log(data);
  //     // this.characteristics = data;
  //   })
  // }
  productTypes: IProductType[] = [];
  currentCategory: ICategory;
  onDetailCategory = (cat: ICategory) => {
    this.currentCategory = cat;
    //console.log(this.currentCategory)
    this.productService.getProductCategorySubType(cat.id).subscribe(data => {
      this.productTypes = data;
      //console.log(this.productTypes)
    }
    )
  }

  get kahpooCommision() {
    return this.categorieForm.get('kahpooCommision');
  }

  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  /*
-----------------------------         for all page attribute    --------------------------------
*/

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  // Only AlphaNumeric
  keyPressAlphanumeric(event) {
    var inp = String.fromCharCode(event.keyCode);

    if (!/[!@#$%°£§^&*$()_+\=\[\]{};:"\\|,.<>\/?]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  onItemSelect(item: any) {
    // let ItemName = item.displayableName
    //this.selectedProductTypes.push(item)
    console.log("List des sous produit")

    console.log(item)
  }
  OnItemDeSelect(item: any) {
  }
  onSelectAll(items: any) {
  }
  onDeSelectAll(items: any) {
  }

  onItemSelectSop(item: any) {
    // let ItemName = item.displayableName
    //this.selectedProductTypes.push(item)
    console.log("List des sous produit")

    console.log(item)
  }
  OnItemDeSelectSop(item: any) {
  }
  onSelectAllSop(items: any) {
  }
  onDeSelectAllSop(items: any) {
  }

  onCategorySelect(event: any) {
    // this.selectedCategory = event;
    // console.log('Catégorie sélectionnée :', this.selectedCategory);
  }
  OnItemDeSelectCategorie(item: any) {
  }

  onEditCategorie(id: any) {
    this.categorieService.getIdCategory_v1(id).subscribe(rs => {
      // console.log("Modification de la catégorie...");
      // console.log(rs)
      this.currentCategorie = rs;
      this.editForm = this.fb.group({
        id: new FormControl(this.currentCategorie.id, []),
        name: new FormControl(this.currentCategorie.name, [Validators.required, NameValidator.notOnlyWhitespace, NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.pattern('^[A-Z-a-z-àéèêëûüîïôö -]+$')]),
        description: new FormControl(this.currentCategorie.description, [Validation.descriptionValidator("La description")]),
        image: new FormControl('', []),
        kahpooCommision: new FormControl(this.currentCategorie.kahpooCommision, [Validators.pattern('^[0-9.]+$')])
      });
    });
  }

  displayErrorMessage: boolean = false;
  onCategorieFormSubmit() {
    if (this.categorieForm.valid) {
      //console.log(this.categorieForm.value);
      const categorie: Category = this.categorieForm.value;

      if (categorie.image === '' || categorie.image === undefined) {
        this.msg = 'Veuillez sélectionner une image';
        this.displayErrorMessage = true;
        return;
      } else {
        this.displayErrorMessage = false;
        this.msg = '';
      }

      const verifyExistingCategory: Category = this.categorie.find(c => c.name.toLowerCase() === categorie.name.toLowerCase());
      if (verifyExistingCategory !== undefined) {
        this.alreadyExist = true;
        return;
      } else {
        this.alreadyExist = false;
      }
      categorie.image = this.image;
      // console.log("Catégorie enregistrée")
      // console.log(categorie)
      this.categorieService.saveCategorie_v1(categorie).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La categorie a été ajoutée avec succés',
          showConfirmButton: false,
          timer: 1500
        });
        this.loadCategorie();
        this.close();
        // console.log(rs);
        this.categorieForm.reset();
        this.categorieForm.get('image').setValue('');
        this.categorieForm.get('kahpooCommision').setValue('');
        this.reloadComponent();
      }, error => {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Veuillez verifier les données',
          showConfirmButton: false,
          timer: 2500
        });
      });
    }
  }


  onEditFormSubmit() {
    //console.log(this.editForm.value);
    const categorie: Category = this.editForm.value;
    categorie.image = this.image;
    categorie.autoSaisieCodePaiement = this.currentCategorie.autoSaisieCodePaiement;
    // console.log("Updated categorie");
    // console.log(categorie);
    this.categorieService.updateCategory_v1(categorie).subscribe(rs => {
      // console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'La categorie a été modifiée avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadCategorie();
      this.close();
      this.reloadComponent();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez verifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  isViewAuditAutorized = false;
  isKahpoo: boolean;
  loadPersonalInformation = () => {
    this.authService.getUSerBySessionId().subscribe(
      (rest: any) => {
        this.user = rest;
        this.isKahpoo = rest.kahpoo;
        // console.log("this.isKahpoo");
        // console.log(this.isKahpoo);
        //console.log("Connected User");
        //console.log(this.user);
        rest.minimizedRoles.forEach(r => {
          this.roleService.getidRole(r).subscribe(r => {
            if (r.name.includes("BACK_OFFICE")) {
              this.isViewAuditAutorized = true;
            }
          })
        })
      }, (error: any) => {
        // console.log(error);
      }
    );
  }

  deleteCategorie(id: any) {
    if (this.isViewAuditAutorized) {
      Swal.fire({
        title: 'SUPPRESSION',
        text: 'Voulez-vous vraiment supprimer cette catégorie ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'OUI',
        denyButtonText: `NON`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.categorieService.deleteCategory(id).subscribe(
            rs => {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'La catégorie a été supprimée avec succés"',
                showConfirmButton: false,
                timer: 1500
              });
              this.loadCategorie();
            }, error => {
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: error.error.errorMessage,
                showConfirmButton: false,
                timer: 2500
              })
            }
          );
        } else if (result.isDenied) {
          Swal.fire({
            icon: 'error',
            text: 'Suppression annulée',

          });
        }
      });
    } else {
      Swal.fire({
        icon: 'error',
        text: 'Vous n\'êtes pas autorisé à supprimer une caractéristique.',
      })
    }

  }


  /*
  -----------------------------          for all page methodes      -----------------------------
   */

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.loadCategorie();
  }
  onTableSizeChange(event: any): void {
    if (event.target.value === 'Tous') {
      this.pageSize = this.totalItems;
    } else {
      this.pageSize = event.target.value;
    }
    // this.pageNumber = 1;
    this.loadCategorie();
  }

  displayPerPage(value: any) {
    this.tableSize = parseInt(value, 10);
    // console.log(this.tableSize);
  }

  searchFilter($event: KeyboardEvent) {
    // this.categorie = this.catagorieTmp.filter(value =>
    //   value.name?.toLowerCase().trim().includes(this.search.toLowerCase().trim()) ||
    //   value.description?.toLowerCase().trim().includes(this.search.toLowerCase().trim())
    // );
    this.categorieService.getAllCategories_v3(this.pageNumber - 1, this.pageSize, this.search).subscribe((data: any) => {
      this.categorie = data.content;
      this.totalItems = data.totalElements;
    }, (err) => {
    });

  }
  /*
  end for all page
   */
  sort1() {
    if (this.sorted1 == false) {
      // @ts-ignore
      this.categorie.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.categorie.sort((a, b) => a.name < b.name ? 1 : a.name > b.name ? -1 : 0);
      this.sorted1 = false;
    }
  }

  // 👧🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥--------------- select file input & read file

  selectFile(event: any) {
    // Angular 11, for stricter type
    const mimeType = event.target.files[0].type;
    //console.log(event.target.files)
    const sizeFile = event.target.files[0].size;
    if (!event.target.files[0] || event.target.files[0].length === 0) {
      this.msg = 'Veuillez sélectionner une image';
      this.displayErrorMessage = true;
    }
    // console.log('size!!!!!');
    // console.log(sizeFile);
    if (sizeFile < 2000000) {
      // console.log(mimeType);

      if (mimeType === 'image/jpeg' || mimeType === 'image/jpg' || mimeType === 'image/svg' || mimeType === 'image/svg+xml' || mimeType === 'image/png') {

        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg = '';
          // alert(this.test)
          this.url = reader.result;
          this.image = this.url;
          //  console.log( this.url);
        };
      } else {

        // this.msg = "Ce type de fichier n'est pas pris en compte.";
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg = 'Ce type de fichier n\'est pas pris en compte.';
          this.url = reader.result;
          this.displayErrorMessage = true;
        };
      }
    } else {
      // this.msg = "la taille de l'image est trop grande";
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.msg = 'La taille de l\'image est trop grande';
        this.displayErrorMessage = true;
        this.url = reader.result;
        this.image = this.url;
        // console.log( this.url);
      };
    }
  }
  // -----------------------------


  close() {
    this.closebutton.nativeElement.click();
    this.closebutton2.nativeElement.click();
  }
}
